module.exports = __webpack_public_path__ + "static/media/pricing2.f7d4aed4.jpg";